import { Avatar, AvatarFallback } from './ui/avatar';
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';

interface CollaborationIndicatorProps {
 owner: { email: string } | string;
 currentUserEmail: string;
}

export function CollaborationIndicator({ owner, currentUserEmail }: CollaborationIndicatorProps) {
 const getInitials = (emailData: string | { email: string }) => {
   const emailStr = typeof emailData === 'string' ? emailData : emailData.email;
   // Add defensive check to handle undefined or empty email strings
   if (!emailStr) return 'UN'; // Return 'UN' for unknown
   return emailStr.split('@')[0].slice(0, 2).toUpperCase();
 };

 const ownerEmail = typeof owner === 'string' ? owner : (owner.email || 'unknown@user.com');
 
 // Only show avatar if the meeting is shared WITH the current user (i.e., they are not the owner)
 if (currentUserEmail === ownerEmail) {
   return null;
 }

 return (
   <div className="flex -space-x-2">
     {/* Owner avatar - shown only when meeting is shared with current user */}
     <Tooltip>
       <TooltipTrigger>
         <Avatar className="h-8 w-8 border-2 border-background ring-2 ring-blue-500">
           <AvatarFallback>
             {getInitials(owner)}
           </AvatarFallback>
         </Avatar>
       </TooltipTrigger>
       <TooltipContent>
         <p>Shared by {ownerEmail}</p>
       </TooltipContent>
     </Tooltip>
   </div>
 );
}
